import * as React from "react";
import { faPhoneAlt } from "@fortawesome/pro-solid-svg-icons/faPhoneAlt";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Price } from "./Price";
export var Block = function (_a) {
  var info = _a.info;
  var imageUrl = info.imageUrl.replace("AGE", window.age.toString());
  return /*#__PURE__*/React.createElement("div", {
    className: "phonesexBlock pink c-phonesex-block"
  }, /*#__PURE__*/React.createElement("h2", null, info.title), /*#__PURE__*/React.createElement("div", {
    style: {
      backgroundImage: "url(" + imageUrl + ")"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "c-phonesex-block__positioner"
  }, /*#__PURE__*/React.createElement("span", null, "Ruf jetzt an:"), /*#__PURE__*/React.createElement("div", {
    className: "phone c-phonesex-block__phone"
  }, /*#__PURE__*/React.createElement("a", {
    href: "tel:" + info.number[window.ABTestOption] + window.callData.webmasterDDI
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faPhoneAlt
  }), " ", info.number[window.ABTestOption], " ", window.callData.webmasterDDI, /*#__PURE__*/React.createElement("sup", null, "*"))))), /*#__PURE__*/React.createElement(Price, null), /*#__PURE__*/React.createElement("p", null, info.description));
};